(function ($) {
  DJ.addBehavior('backToTop', '.back-to-top', {
    attach: function () {
      const button = this;

      /**
       * Scroll the page up on click.
       */
      button.addEventListener('click', () => {
        $('html, body').animate({ scrollTop: 0 }, '300');
      });
    }
  });
})(jQuery);
